import ENV from '../../run-config';
/* eslint-disable */

import icon_rlboe from '../../images/rlboe/icon.jpg';
import logo_rlboe from '../../images/rlboe/logo.jpg';

import logo_eba from '../../images/logo_eba.png';
import logo_whitelabel from '../../images/logo_whitelabel.png';
import logo_slam from '../../images/slam/logo_slam_uncut.png';
import logo_rlb from '../../images/logo_rlb.png';
import logo_customerexpert from '../../images/customerexpert/logo_customerexpert.png';

import icon_eba from '../../images/icon_eba.png';
import icon_whitelabel from '../../images/icon_whitelabel.png';
import icon_rlb from '../../images/icon_rlb.png';
import icon_customerexpert from '../../images/customerexpert/icon_customerexpert.png';

import landingpage_customerexpert_header from '../../images/customerexpert/landingpage/header.jpg';
import landingpage_customerexpert_header_2 from '../../images/customerexpert/landingpage/appstore_screens.png';
import landingpage_customerexpert_header_image from '../../images/customerexpert/landingpage/mobile.png';
import landingpage_customerexpert_body_image from '../../images/customerexpert/landingpage/body.jpg';
import landingpage_customerexpert_body_image2 from '../../images/customerexpert/landingpage/body2.png';
import landingpage_customerexpert_video_preview from '../../images/customerexpert/landingpage/video_preview.jpg'
import landingpage_customerexpert_title from '../../images/customerexpert/landingpage/folder.jpg'

const { brand } = ENV;

let images;

if (brand === 'eba') {
  images = {
    logoPath: logo_eba,
    iconPath: icon_eba,
  };
} else if (brand === 'rlb') {
  images = {
    logoPath: logo_rlb,
    iconPath: icon_rlb,
  };
} else if (brand === 'rlboe') {
  images = {
    logoPath: logo_rlboe,
    iconPath: icon_rlboe,
  };
} else if (brand === 'customerexpert') {
  images = {
    logoPath: logo_customerexpert,
    iconPath: logo_customerexpert,
    landingpageHeader: landingpage_customerexpert_header,
    landingpageHeader2: landingpage_customerexpert_header_2, 
    landingpageHeaderImage: landingpage_customerexpert_header_image,
    landingpageBodyImage: landingpage_customerexpert_body_image,
    landingpageBody2Image: landingpage_customerexpert_body_image2,
    landingpageVideoPreview: landingpage_customerexpert_video_preview,
    landingpageTitle: landingpage_customerexpert_title,
  };
} else {
  images = {
    logoPath: logo_slam,
    iconPath: logo_slam,
  };
}

export default(images);
/* eslint-disable */


// WEBPACK FOOTER //
// ./src/app/theme/images.js